import React, { Component } from "react";
import { Icon, ImageEditor, ModalDialog, PlainButton } from "@culturehq/components";
import { generateThumbnail, t, Trans } from "app/utils";

import ChqModalDialog from "components/common/ChqModalDialog";
import Control from "./Control";

const fileToImage = file => ({
  src: URL.createObjectURL(file),
  alt: file.name,
  file
});

class ImageControl extends Component {
  field = React.createRef();

  static defaultProps = {
    aspectRatio: null,
    singleImage: false,
    buttonView: false
  };

  state = {
    editorOpen: false,
    currentImage: null
  };

  componentDidMount() {
    const { openImageLibrary } = this.props;
    if (openImageLibrary) {
      this.handleClick();
    }
  }

  isImageType = files => files.every(file => file.type.startsWith("image"));

  accept = () => {
    const { mediaType = "image" } = this.props;

    if (mediaType === "image" || mediaType === "video") return `${mediaType}/*`;
    return "image/*,video/*";
  }

  handleClick = () => {
    this.field.current.value = null;
    this.field.current.click();
  };

  handleImageChange = images => {
    const { onImagesSelected } = this.props;

    if (images.length === 1) {
      this.setState({
        editorOpen: true,
        currentImage: fileToImage(images[0])
      });
    } else {
      onImagesSelected(images.map(fileToImage));
    }
  };

  handleVideoChange = async videos => {
    const { onImagesSelected } = this.props;

    const video = videos[0];
    const thumbnail = await generateThumbnail(video, 2);

    this.handleClose();
    onImagesSelected([fileToImage(thumbnail)], fileToImage(video));
  };

  handleChange = ({ target }) => {
    const files = Array.from(target.files);

    if (this.isImageType(files)) this.handleImageChange(files);
    else this.handleVideoChange(files);
  };

  handleImageEdited = editedImage => {
    const { onImagesSelected } = this.props;
    const { currentImage } = this.state;

    this.handleClose();

    if (currentImage) {
      onImagesSelected(
        [{
          src: URL.createObjectURL(editedImage),
          alt: currentImage.alt,
          file: editedImage
        }],
        currentImage
      );
    }
  };

  handleClose = () => {
    this.setState({
      editorOpen: false,
      currentImage: null
    });
  };

  render() {
    const { buttonTitle, aspectRatio, buttonView, singleImage } = this.props;
    const { editorOpen, currentImage } = this.state;
    const accept = this.accept();

    return (
      <>
        {buttonView ? (
          <PlainButton onClick={this.handleClick}>
            <input
              type="file"
              accept={accept}
              multiple={!singleImage}
              ref={this.field}
              onChange={this.handleChange}
              style={{ display: "none" }}
            />
            <Icon icon="upload-image" />
            <Trans>{buttonTitle || "Upload image"}</Trans>
          </PlainButton>
        ) : (
          <Control ariaLabel={t("Add an image")} onClick={this.handleClick} className="chq-edi--ct-left">
            <input
              type="file"
              accept={accept}
              multiple={!singleImage}
              ref={this.field}
              onChange={this.handleChange}
              style={{ display: "none" }}
            />
            <Icon icon="image-add" />
          </Control>
        )}
        {editorOpen && (
          <ChqModalDialog onClose={this.handleClose}>
            <ModalDialog.Body>
              <ImageEditor
                aspectRatio={aspectRatio}
                image={currentImage.src}
                onEdit={this.handleImageEdited}
                onFailure={this.handleClose}
              />
            </ModalDialog.Body>
          </ChqModalDialog>
        )}
      </>
    );
  }
}

export default ImageControl;
